import { ProductPropertiesKeyAPI } from '~/api/Catalog';
import { ProductState } from '~/stores/CategoriesStore';
import {
  ProductFilterChoice,
  ProductPropertiesValue,
} from '~/types/Product/interface';

import { getProductLimit } from './useProductLimit';

export const useProductChoices = ({
  product,
}: {
  product?: ProductState;
}): Record<string, ProductPropertiesValueExtended> => {
  if (!product) {
    return {};
  }

  const productFilters = product?.selectedOffer?.selectableProperties;
  const selectedProperties = Object.values(
    product?.selectedOffer?.selectableProperties ?? {},
  ).reduce(
    (
      acc: Record<string, string | number | boolean | string[]>,
      item: ProductPropertiesValue,
    ) => {
      acc[item.code] = item.value;
      return acc;
    },
    {},
  );

  return Object.fromEntries(
    Object.entries(productFilters ?? {}).map(([key, value]) => {
      const choices = value.choices.map((choice) => {
        let sku = '',
          sellable = false,
          selected = false;

        if (
          choice.label ===
          product?.selectedOffer?.selectableProperties[
            key as ProductPropertiesKeyAPI
          ]?.value
        ) {
          selected = true;
        }

        for (const offer of product?.data?.offers ?? []) {
          if (
            choice.label ===
            offer.selectableProperties[key as ProductPropertiesKeyAPI]?.value
          ) {
            let ok = true;
            Object.entries(selectedProperties).forEach(
              ([selectedKey, selectedValue]) => {
                if (selectedKey !== key) {
                  if (
                    selectedValue !==
                    offer.selectableProperties[
                      selectedKey as ProductPropertiesKeyAPI
                    ]?.value
                  ) {
                    ok = false;
                  }
                }
              },
            );

            if (ok) {
              sku = offer.sku;
              const { limit } = getProductLimit(offer);

              if (limit > 0) {
                sellable = true;
              }
            }
          }
        }

        return { ...choice, sku, sellable, selected };
      });

      return [key, { ...value, choices }];
    }),
  );
};

export interface ProductFilterChoiceExtended extends ProductFilterChoice {
  sku: string;
  sellable: boolean;
  selected: boolean;
}

export interface ProductPropertiesValueExtended
  extends Omit<ProductPropertiesValue, 'choices'> {
  choices: ProductFilterChoiceExtended[];
}
